export default {"src":"/_next/static/media/bars-solid.0b45829a.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};